/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const TRIAGE_STATUSES = [
  'seed',
  'sanitized',
  'prefilled',
  'draft',
  'populated',
  'reset',
  'approved',
  'flagged',
  'rejected',
  'disabled',
  'clipless',
] as const;

export const triageStatusSchema = z.enum(TRIAGE_STATUSES);

export type ITriageStatus = z.infer<typeof triageStatusSchema>;

export const POPULATED_STATUSES = ['populated', 'reset', 'approved'] as const;
export const UNPOPULATED_STATUSES = ['seed', 'sanitized', 'prefilled', 'draft'] as const;
export const ACTIVE_STATUSES = [...POPULATED_STATUSES, ...UNPOPULATED_STATUSES] as const;

export const INACTIVE_STATUSES = ['disabled', 'clipless'] as const;
export const NEVER_SERVED_FOR_TRIAGE_STATUSES = ['disabled', 'rejected', 'clipless'] as const;
